import axios from "axios";

// Fire-and-forget persistence of the journey's captured location to a DEDICATED
// endpoint.
//
// Unlike updateJourney(), this has NO journey state-machine side effects — no
// orchestration, no journey-done/expiry handling, no global error flag — and the
// caller never awaits it. So persisting location can never block, hang, or bounce
// the user to an error/expired screen. Failures are swallowed; any real session
// problem surfaces on the user's next foreground action.
//
// `location` is either { latitude, longitude } (success) or
// { status: "DENIED" | "ERROR", reason, permissionDenied } (denied/error).
export function captureLocationApi({ journeyId, location }) {
  try {
    axios
      .post("/otk-service/capture-location", { journeyId, location })
      .catch((err) =>
        console.error("[captureLocationApi] failed (ignored):", err?.message)
      );
  } catch (err) {
    console.error("[captureLocationApi] failed (ignored):", err?.message);
  }
}
